import React from 'react'
import { Form } from 'rsuite'
import Icon from './Icon'
import ContestPicker from './ContestPicker'

/**
 * Choose the race to show, in the preferences and the kiosk options: the newest race is followed
 * live unless another one is chosen
 * @param {Object} props component props
 * @param {Function} props.onClose called after choosing, to close the options
 * @returns {JSX.Element} form group with the race picker
 */
const RaceOptions = ( { onClose = null } ) =>
(
  <Form.Group className="contest">
    <Form.ControlLabel><Icon icon="calendar"/> Race</Form.ControlLabel>
    <ContestPicker onClose={ onClose }/>
  </Form.Group>
)

export default RaceOptions
